import { CSSProperties } from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { SxProps, Theme } from "@mui/system";

import Button from "@mui/material/Button";
import { SimpleText } from "../index";
import { RootState } from "../../redux/store.ts";
import { useSelector } from "react-redux";

interface PropType {
  buttonLabel: string;
  tooltipText?: string;
  loading?: boolean;
  onClick: () => void;
  variant?: "contained" | "outlined" | "text";
  disabled?: boolean;
  type?: "mainButton" | "subButton" | "redButton";
  style?: CSSProperties;
  backgroundColor?: string;
  height?: string;
  hoverBackground?: string;
  color?: string;
  borderColor?: string;
  sx: SxProps<Theme>;
}

const SimpleInput = (props: PropType) => {
  const {
    buttonLabel,
    tooltipText,
    loading = false,
    onClick,
    variant = "contained",
    disabled = false,
    style,

    height,
    sx,
    type = "mainTitle",
  } = props;
  const { contrast } = useSelector(
    (state: RootState) => state?.settings?.data?.disability,
  );
  return (
    <Tooltip title={tooltipText} arrow disableHoverListener={!tooltipText}>
      <Box
        style={style}
        sx={[
          ...(Array.isArray(sx) ? sx : [sx]),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Button
          style={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "16px",
          }}
          //variant={variant}
          onClick={onClick}
          disabled={disabled || loading}
          sx={{
            textTransform: "none",
            outline: "none",
            boxShadow: "none",
            "&:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "&:hover": {
              background:
                type == "redButton"
                  ? "#DE4E4D"
                  : type == "mainButton"
                    ? variant == "outlined"
                      ? contrast
                        ? "#d9d9d9"
                        : "#dce9fa"
                      : contrast
                        ? "#141414"
                        : "#00187a"
                    : contrast
                      ? "#424242"
                      : "#858585",
              boxShadow: "0px 0px 0px rgba(0, 0, 0, 0.2)",
              border: `${variant == "outlined" ? "2px" : "0px"} solid ${variant == "outlined" ? (contrast ? "#141414" : "#001E96") : "#fff"}`,
            },
            "&.Mui-disabled": {
              backgroundColor: contrast ? "#d9d9d9" : "#CCD2EA",
              color: "#ffffff",
            },
            width: "100%",
            height: height || "46px",
            fontSize: "18px",
            fontWeight: "bold",
            background:
              type == "redButton"
                ? "#DE4E4D"
                : type == "mainButton"
                  ? variant == "outlined"
                    ? "#fff"
                    : contrast
                      ? "black"
                      : "#001E96"
                  : contrast
                    ? "#525252"
                    : "#999999",
            borderRadius: "8px",
            paddingBottom: "9px",
            border: `${variant == "outlined" ? "2px" : "0px"} solid ${variant == "outlined" ? (contrast ? "#141414" : "#001E96") : "#fff"}`,
            paddingLeft: "20px",
            paddingRight: "20px",
          }}
        >
          {loading ? (
            <CircularProgress size={24} style={{ position: "absolute" }} />
          ) : (
            <SimpleText
              value={buttonLabel}
              type={"codeText"}
              style={{
                color:
                  type == "mainButton"
                    ? variant == "outlined"
                      ? contrast
                        ? "#000"
                        : "#001E96"
                      : "#fff"
                    : "#fff",
              }}
            />
          )}
        </Button>
      </Box>
    </Tooltip>
  );
};

export default SimpleInput;
